import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  viewCourse: {
    id: 'courseCardMinimal.viewCourse',
    defaultMessage: 'View {title}',
    description: 'Accessible label for a course card link',
  },
  bannerAlt: {
    id: 'courseCardMinimal.bannerAlt',
    defaultMessage: '{title} course image',
    description: 'Alt text for a course card banner image',
  },
  inactive: {
    id: 'courseCardMinimal.inactive',
    defaultMessage: 'Inactive',
    description: 'Badge shown on a course card whose enrollment is not active',
  },
});

export default messages;
